import { TbClock, TbShield, TbShieldOff, TbShieldHalf, TbPencil, TbTrash, TbUsers, TbUserPlus } from "react-icons/tb";

const POLICY_CONFIG = {
  free: {
    label: "Annulation gratuite",
    icon: TbShield,
    bg: "bg-green-50",
    text: "text-green-700",
    border: "border-green-100",
    dot: "bg-green-400"
  },
  partial: {
    label: "Partielle",
    icon: TbShieldHalf,
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-100",
    dot: "bg-amber-400"
  },
  non_refundable: {
    label: "Non remboursable",
    icon: TbShieldOff,
    bg: "bg-red-50",
    text: "text-red-600",
    border: "border-red-100",
    dot: "bg-red-400"
  }
};

const MEAL_LABELS = {
  none: null,
  breakfast: { label: "Petit-déjeuner", emoji: "🍳" },
  half_board: { label: "Demi-pension", emoji: "🍽️" },
  full_board: { label: "Pension complète", emoji: "🍱" }
};

const Chip = ({ icon: Icon, label, bg, text, border }) => (
  <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg border text-[11px] font-medium whitespace-nowrap ${bg} ${text} ${border}`}>
    {Icon && <Icon className="shrink-0 text-[11px]" />}
    <span>{label}</span>
  </div>
);

const RatePlanCard = ({ plan, handleEdit, handleDelete }) => {
  const policyType = plan.cancellationPolicy?.type || "free";
  const policy = POLICY_CONFIG[policyType];
  const PolicyIcon = policy.icon;
  const meal = MEAL_LABELS[plan.mealPlan];
  const guestPolicy = plan.extraGuestPolicy;
  const hasGuestFees = guestPolicy?.extraAdultFee > 0 || guestPolicy?.extraChildFee > 0;

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-4 flex flex-col gap-3 hover:border-gray-200 hover:shadow-md hover:shadow-gray-100 hover:-translate-y-0.5 transition-all duration-200 h-full">

      {/* HEADER */}
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[10px] font-bold text-gray-300 uppercase tracking-widest mb-0.5">Tarif</p>
          <h3 className="text-sm font-bold text-gray-900 truncate">{plan.name}</h3>
          {plan.description && (
            <p className="text-[11px] text-gray-400 mt-1 line-clamp-2 leading-relaxed">{plan.description}</p>
          )}
        </div>
        <div className={`w-2 h-2 rounded-full shrink-0 mt-1.5 ${policy.dot}`} />
      </div>

      {/* CHIPS */}
      <div className="flex flex-wrap gap-1.5">
        <Chip
          icon={PolicyIcon}
          label={policyType === "partial"
            ? `Partielle — ${plan.cancellationPolicy?.penaltyPercentage}%`
            : policy.label
          }
          bg={policy.bg}
          text={policy.text}
          border={policy.border}
        />

        {meal && (
          <div className="inline-flex items-center gap-1 px-2 py-1 rounded-lg border text-[11px] font-medium whitespace-nowrap bg-blue-50 text-blue-700 border-blue-100">
            <span className="text-[11px]">{meal.emoji}</span>
            <span>{meal.label}</span>
          </div>
        )}

        {policyType !== "non_refundable" && plan.cancellationPolicy?.hoursBeforeArrival > 0 && (
          <Chip
            icon={TbClock}
            label={`Jusqu'à ${plan.cancellationPolicy.hoursBeforeArrival}h`}
            bg="bg-gray-50"
            text="text-gray-500"
            border="border-gray-100"
          />
        )}

        {guestPolicy?.baseOccupancy > 0 && (
          <Chip
            icon={TbUsers}
            label={`Base ${guestPolicy.baseOccupancy} pers.`}
            bg="bg-purple-50"
            text="text-purple-700"
            border="border-purple-100"
          />
        )}

        {hasGuestFees && (
          <Chip
            icon={TbUserPlus}
            label={`+${guestPolicy.extraAdultFee}€/adulte`}
            bg="bg-indigo-50"
            text="text-indigo-700"
            border="border-indigo-100"
          />
        )}
      </div>

      {/* ACTIONS */}
      <div className="flex gap-2 pt-3 border-t border-gray-50 mt-auto">
        <button
          onClick={() => handleEdit(plan)}
          className="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-[#3A9D23] text-xs font-semibold hover:bg-green-50 transition-all duration-150"
        >
          <TbPencil className="text-sm" />
          Modifier
        </button>
        <div className="w-px bg-gray-100" />
        <button
          onClick={() => handleDelete(plan)}
          className="flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-red-400 text-xs font-semibold hover:bg-red-50 transition-all duration-150"
        >
          <TbTrash className="text-sm" />
          Supprimer
        </button>
      </div>

    </div>
  );
};

export default RatePlanCard;